/**
 * AccouPro Unified Form Design System Tokens
 * Standard dimensions, heights, paddings, and typography across all forms
 */

export const FORM_TOKENS = {
  // Modal Dimensions
  modal: {
    transaction: "max-w-[1050px] w-full max-h-[90vh] h-[90vh] sm:h-auto rounded-none sm:rounded-2xl",
    standard: "max-w-2xl w-full max-h-[88vh] rounded-none sm:rounded-2xl",
    compact: "max-w-md w-full max-h-[85vh] rounded-none sm:rounded-xl",
  },

  // Control Heights
  controlHeight: {
    default: "h-9", // 36px standard control height
    sm: "h-8",      // 32px compact table row controls
    lg: "h-10",     // 40px prominent buttons
  },

  // Padding Standards
  padding: {
    modalHeader: "px-5 py-3.5 sm:px-7 sm:py-4",
    modalBody: "px-5 py-5 sm:px-7 sm:py-6 space-y-5",
    modalFooter: "px-5 py-3.5 sm:px-7 sm:py-4",
    section: "p-4 sm:p-5",
  },

  // Typography
  typography: {
    label: "text-xs font-semibold text-slate-500 uppercase tracking-wider block mb-1.5",
    input: "text-xs sm:text-sm font-medium text-slate-900 placeholder:text-slate-400",
    sectionTitle: "text-xs sm:text-sm font-bold text-slate-900 tracking-tight flex items-center gap-2",
    sectionSubtitle: "text-[11px] text-slate-500",
    modalTitle: "text-base sm:text-lg font-bold font-display text-slate-900 tracking-tight",
    modalSubtitle: "text-xs text-slate-500 mt-0.5",
  },

  // Surfaces & Borders (Clean, Bright Enterprise SaaS)
  surfaces: {
    card: "bg-white border border-slate-200 rounded-xl shadow-2xs",
    header: "bg-white border-b border-slate-200",
    footer: "bg-slate-50 border-t border-slate-200",
    input: "bg-white border border-slate-200 text-slate-900 rounded-lg focus:border-blue-600 focus:ring-2 focus:ring-blue-600/20 transition-all",
  },
} as const;
